import React from "react";
import { PageHeader } from "@/components/site/PageHeader";
import { SiteFooter } from "@/components/site/FinalCTA";
import { PAGES } from "@/constants/testIds";
import { ExternalLink } from "lucide-react";

const INDIAS_URL = "https://indias.com";

export default function ExploreIndiaPage() {
  return (
    <div data-testid={PAGES.explore} className="min-h-screen bg-ivory text-ink">
      <PageHeader
        eyebrow="Explore India · Powered by Indias.com"
        title="A frame on the"
        italic="subcontinent."
        subtitle="Places, districts, festivals and the everyday poetry of India — served from our sister site, Indias.com. Browse it right here without leaving the archive."
      >
        <div className="mt-6">
          <a
            href={INDIAS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-ink/25 px-5 py-2.5 text-sm hover:border-ink hover:bg-ink hover:text-ivory transition"
          >
            <ExternalLink size={14} /> Open Indias.com in a new tab
          </a>
        </div>
      </PageHeader>

      <section className="relative py-8 md:py-14">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="relative border border-ivory-300 rounded-2xl overflow-hidden bg-ivory shadow-[0_20px_80px_-30px_rgba(10,15,13,0.25)]">
            <div className="flex items-center gap-2 px-4 py-3 border-b border-ivory-300 bg-ivory-100">
              <span className="w-2.5 h-2.5 rounded-full bg-rust/50" />
              <span className="w-2.5 h-2.5 rounded-full bg-marigold/70" />
              <span className="w-2.5 h-2.5 rounded-full bg-tulsi/60" />
              <span className="ml-4 text-xs text-ink-50 font-mono">indias.com</span>
            </div>
            <iframe
              src={INDIAS_URL}
              title="Indias.com — Explore India"
              className="w-full h-[75vh] bg-ivory"
              loading="lazy"
              referrerPolicy="no-referrer"
              sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
            />
          </div>
          <p className="mt-4 text-xs text-ink-50">
            Content served in the frame belongs to Indias.com. Some pages may decline
            embedding — in that case, use the "Open in a new tab" button above.
          </p>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
